@if (stbState$ | async; as stbState) {
  <div class="av-input-indicator">
    @if (stbState.currentInputType) {
      <div>
        <div>
          @switch (stbState.currentInputType) {
            @case (1) {
              <span>DVB-T/{{stbState.currentInputIndex}}</span>
            }
            @case (6) {
              <span>HDMI/{{stbState.currentInputIndex}}</span>
            }
            @case (8) {
              <span>OTHER/{{stbState.currentInputIndex}}</span>
            }
          }
        </div>
      </div>
    }
  </div>
}
